export * from './constants/url';
export {
  deviceType,
  getLang,
  getPlatformOS,
  isEmmaApp,
  isInsideBrowser,
  isMobileBrowser,
  nameof,
  platformStr,
} from './helpers/common';
export { getClientConfig } from './helpers/get-client-config';
export { getDocReferrer } from './helpers/get-doc-referrer';
export {
  getGoogleMapLang,
  getMapLink,
  MAP_ANDROID_URL,
  MAP_LOCATION_URL,
} from './helpers/get-map-link';
export { maskEmail } from './helpers/mask-email';
export { maskMobileNumber } from './helpers/mask-mobile-number';
export { getPoliciesRegion, getPolicyRegion } from './helpers/policy-helper';
export {
  getDataFromUrl,
  getPathRegexpFromEmmaUrl,
  getUrlWithParams,
} from './helpers/url';
export { setCustomerLogin, useCustomerLogin } from './hooks/customer-login';
export type { CustomerLogin, Policy, Profile } from './hooks/customer-login';
export { setGoto, useGoto } from './hooks/goto';
export { singletonCallback, singletonState } from './hooks/singleton-hooks';
export { useDataFromUrl, useUrlWithParams } from './hooks/url';
export { sliceVirtualPage, useInfiniteScroll } from './hooks/useInfiniteScroll';
export { useScopedSelector } from './hooks/useScopedSelector';

// CMS Profile -
export { CMSProfile } from './helpers/cms-profile';

// Ensure the name used in components is useLayoutEffect
export { default as useLayoutEffect } from './hooks/use-isomorphic-layout-effect';
export { useEmmaJS } from './hooks/useEmmaJS';
export { useMobileTopBar } from './hooks/useMobileTopBar';
export { default as useNormalMobileTopBar } from './hooks/useNormalMobileTopBar';
export { useOpenLink } from './hooks/useOpenLink';
export { useOverrideCloseEvent } from './hooks/useOverrideCloseEvent';

export * from './types/policy-types';
